import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../api';

const COUNTRIES = [
  { code:'CN', name:'中国', flag:'🇨🇳' }, { code:'JP', name:'日本', flag:'🇯🇵' },
  { code:'KR', name:'韩国', flag:'🇰🇷' }, { code:'US', name:'美国', flag:'🇺🇸' },
  { code:'GB', name:'英国', flag:'🇬🇧' }, { code:'FR', name:'法国', flag:'🇫🇷' },
  { code:'DE', name:'德国', flag:'🇩🇪' }, { code:'IT', name:'意大利', flag:'🇮🇹' },
  { code:'ES', name:'西班牙', flag:'🇪🇸' }, { code:'RU', name:'俄罗斯', flag:'🇷🇺' },
  { code:'BR', name:'巴西', flag:'🇧🇷' }, { code:'CA', name:'加拿大', flag:'🇨🇦' },
  { code:'AU', name:'澳大利亚', flag:'🇦🇺' }, { code:'IN', name:'印度', flag:'🇮🇳' },
  { code:'TH', name:'泰国', flag:'🇹🇭' }, { code:'VN', name:'越南', flag:'🇻🇳' },
  { code:'SG', name:'新加坡', flag:'🇸🇬' }, { code:'MY', name:'马来西亚', flag:'🇲🇾' },
  { code:'PH', name:'菲律宾', flag:'🇵🇭' }, { code:'ID', name:'印度尼西亚', flag:'🇮🇩' },
];

const FLAGS = { CN:'🇨🇳',JP:'🇯🇵',KR:'🇰🇷',US:'🇺🇸',GB:'🇬🇧',FR:'🇫🇷',DE:'🇩🇪',IT:'🇮🇹',ES:'🇪🇸',RU:'🇷🇺',BR:'🇧🇷',CA:'🇨🇦',AU:'🇦🇺',IN:'🇮🇳',TH:'🇹🇭',VN:'🇻🇳',SG:'🇸🇬',MY:'🇲🇾',PH:'🇵🇭',ID:'🇮🇩' };
const CURR_SYM = { USD:'$',EUR:'€',JPY:'¥',CNY:'¥',KRW:'₩',RUB:'₽' };

export default function ShopPage() {
  const [shop, setShop] = useState(null);
  const [tab, setTab] = useState('overview');
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ name:'', description:'', country_code:'', logo:'🏪', legalPerson:{name:'', idType:'passport', idNumber:'', phone:'', email:''}, languages:['en'] });
  const [products, setProducts] = useState([]);
  const [showProductForm, setShowProductForm] = useState(false);
  const [pForm, setPForm] = useState({ title:'', description:'', price:'', currency:'USD', image:'📦', category:'handmade' });
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  useEffect(() => { loadShop(); }, []);
  const loadShop = async () => {
    try { const r = await API.get('/shops/my'); setShop(r.data); if (r.data?.owner_id) { const p = await API.get('/market/my-products'); setProducts(p.data); } } catch {}
  };

  const createShop = async () => {
    if (!form.name || !form.country_code) return setMsg('店名和国家必填');
    try {
      await API.post('/shops/create', form);
      setMsg('🎉 店铺创建成功！30天免费试用');
      setShowCreate(false);
      await loadShop();
      setTimeout(() => setMsg(''), 3000);
    } catch (err) { setMsg(err.response?.data?.error || '创建失败'); }
  };

  const publishProduct = async () => {
    if (!pForm.title || !pForm.price) return setMsg('标题和价格必填');
    try {
      await API.post('/market/products', pForm);
      setMsg('✅ 商品上架成功！');
      setShowProductForm(false);
      setPForm({ title:'', description:'', price:'', currency:'USD', image:'📦', category:'handmade' });
      const p = await API.get('/market/my-products');
      setProducts(p.data);
      setTimeout(() => setMsg(''), 2000);
    } catch { setMsg('❌ 发布失败'); }
  };

  const upgradeShop = async (planId) => {
    try {
      const r = await API.post('/shops/upgrade', { planId });
      if (r.data.url) { window.location.href = r.data.url; return; }
      setMsg(r.data.message);
      await loadShop();
      setTimeout(() => setMsg(''), 3000);
    } catch { setMsg('升级失败'); }
  };

  const maxProducts = shop?.tierInfo?.maxProducts || 5;

  if (!shop && !showCreate) {
    return (
      <div className="page-content">
        <div className="discovery-header"><h2>🏪 全球开店</h2><p className="subtitle">30天免费试用，卖你的本土好物给全世界</p></div>

        {/* 开店流程引导 */}
        <div className="plans-grid" style={{maxWidth:700}}>
          <div className="plan-card" style={{textAlign:'center',padding:40}}>
            <div style={{fontSize:'4rem',marginBottom:16}}>🏪</div>
            <h3>开店只需三步</h3>
            <div style={{display:'flex',flexDirection:'column',gap:12,margin:'20px 0',textAlign:'left',padding:'0 20px'}}>
              <div>1️⃣ 填写店铺信息（店名 + 国家）</div>
              <div>2️⃣ 上架你的本土商品</div>
              <div>3️⃣ 全球用户下单购买</div>
            </div>
            <div className="profile-tags" style={{justifyContent:'center',marginBottom:20}}>
              <span className="tag">🆓 30天免费</span>
              <span className="tag">🌍 卖向全球</span>
              <span className="tag">💳 自动收款</span>
            </div>
            <p style={{fontSize:'0.82rem',color:'var(--text-dim)',marginBottom:20}}>
              30天后仅 $2.99/月起，包含最多20件商品，佣金仅10%
            </p>
            <button className="btn btn-primary" style={{fontSize:'1.1rem',padding:'14px 40px'}} onClick={() => setShowCreate(true)}>
              🚀 立即开店
            </button>
          </div>

          {/* 店铺套餐对比 */}
          <div className="plan-card popular" style={{textAlign:'center',padding:40}}>
            <div className="plan-badge">🔥 推荐</div>
            <h3>💎 店铺套餐</h3>
            <ShopPlans onUpgrade={() => setShowCreate(true)} />
          </div>
        </div>

        <div style={{textAlign:'center',margin:24}}>
          <button className="btn btn-secondary" onClick={() => navigate('/marketplace')}>🛒 逛逛商城</button>
        </div>

        {/* 开店表单弹窗 */}
        {showCreate && (
          <div className="chat-overlay" onClick={e => e.target===e.currentTarget && setShowCreate(false)}>
            <div className="chat-box" style={{maxWidth:500,height:'auto',maxHeight:'90vh'}}>
              <div className="chat-header"><h3>🏪 开一家全球小店</h3><button className="btn-icon" onClick={()=>setShowCreate(false)}>✕</button></div>
              <div style={{padding:20}}>
                {msg && <div className="alert" style={msg.includes('成功')||msg.includes('🎉')?{background:'rgba(74,222,128,0.15)',color:'#4ade80',border:'1px solid rgba(74,222,128,0.2)'}:{background:'rgba(255,107,107,0.15)',color:'#ff6b6b'}}>{msg}</div>}
                <div className="field"><label>🏪 店铺名称</label><input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="例如：东京和风小屋" /></div>
                <div className="field"><label>📝 店铺介绍</label><textarea value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} rows={2} placeholder="介绍一下你的店和国家的特色..." /></div>
                <div className="field"><label>🌍 所在国家</label>
                  <select value={form.country_code} onChange={e=>setForm(f=>({...f,country_code:e.target.value}))}>
                    <option value="">选择国家</option>
                    {COUNTRIES.map(c => <option key={c.code} value={c.code}>{c.flag} {c.name}</option>)}
                  </select>
                </div>
                <div className="field"><label>🏪 Logo Emoji</label><input value={form.logo} onChange={e=>setForm(f=>({...f,logo:e.target.value}))} placeholder="🏪" maxLength={2} /></div>

                <h4 style={{marginBottom:12,color:'var(--text-dim)',fontSize:'0.9rem'}}>📋 企业/法人信息（用于审核）</h4>
                <div className="field"><label>👤 法人姓名</label><input value={form.legalPerson.name} onChange={e=>setForm(f=>({...f,legalPerson:{...f.legalPerson,name:e.target.value}}))} placeholder="真实姓名" /></div>
                <div style={{display:'flex',gap:10}}>
                  <div className="field" style={{width:100}}><label>证件类型</label><select value={form.legalPerson.idType} onChange={e=>setForm(f=>({...f,legalPerson:{...f.legalPerson,idType:e.target.value}}))}><option value="passport">护照</option><option value="idcard">身份证</option><option value="business">营业执照</option></select></div>
                  <div className="field" style={{flex:1}}><label>证件号</label><input value={form.legalPerson.idNumber} onChange={e=>setForm(f=>({...f,legalPerson:{...f.legalPerson,idNumber:e.target.value}}))} placeholder="证件号码" /></div>
                </div>
                <div style={{display:'flex',gap:10}}>
                  <div className="field" style={{flex:1}}><label>📞 电话</label><input value={form.legalPerson.phone} onChange={e=>setForm(f=>({...f,legalPerson:{...f.legalPerson,phone:e.target.value}}))} placeholder="国际电话" /></div>
                </div>
                <div className="field"><label>📧 邮箱</label><input value={form.legalPerson.email} onChange={e=>setForm(f=>({...f,legalPerson:{...f.legalPerson,email:e.target.value}}))} placeholder="联系邮箱" /></div>
                <h4 style={{margin:'12px 0',color:'var(--text-dim)',fontSize:'0.9rem'}}>🌐 店铺支持语言</h4>
                <div className="lang-options" style={{marginBottom:16}}>
                  {['en','zh','ja','ko','es','fr','it','ru','de','pt'].map(code => (
                    <button key={code} type="button" className={`lang-btn ${form.languages.includes(code)?'selected':''}`}
                      onClick={()=>setForm(f=>({...f,languages:f.languages.includes(code)?f.languages.filter(c=>c!==code):[...f.languages,code]}))}>
                      {{en:'🇺🇸',zh:'🇨🇳',ja:'🇯🇵',ko:'🇰🇷',es:'🇪🇸',fr:'🇫🇷',it:'🇮🇹',ru:'🇷🇺',de:'🇩🇪',pt:'🇵🇹'}[code]}
                    </button>
                  ))}
                </div>
                <button className="btn btn-primary btn-block" onClick={createShop}>📋 提交审核开店</button>
                <p style={{fontSize:'0.75rem',color:'var(--text-dim)',textAlign:'center',marginTop:12}}>提交后1-2个工作日审核 · 通过后30天免费试用</p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ── 店铺管理后台 ──
  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>{shop?.logo || '🏪'} {shop?.name}</h2>
        <p className="subtitle">
          {FLAGS[shop?.country_code]||'🌍'} {shop?.country_code} · {shop?.tierInfo?.badge} {shop?.tierInfo?.label}
          {shop?.tier === 'trial' && shop?.trialDaysLeft > 0 ? ` · 试用剩余 ${shop.trialDaysLeft} 天` : ''}
        </p>
      </div>

      {msg && <div className="alert" style={msg.includes('成功')||msg.includes('🎉')?{background:'rgba(74,222,128,0.15)',color:'#4ade80',textAlign:'center',border:'1px solid rgba(74,222,128,0.2)'}:{background:'rgba(255,107,107,0.15)',color:'#ff6b6b',textAlign:'center'}}>{msg}</div>}

      {/* Tab */}
      <div className="discovery-filters">
        <button className={`filter-btn ${tab==='overview'?'active':''}`} onClick={()=>setTab('overview')}>📊 概况</button>
        <button className={`filter-btn ${tab==='products'?'active':''}`} onClick={()=>setTab('products')}>📦 商品 ({products.length}/{maxProducts === -1 ? '∞' : maxProducts})</button>
        <button className={`filter-btn ${tab==='upgrade'?'active':''}`} onClick={()=>setTab('upgrade')}>💎 升级</button>
      </div>

      {tab === 'overview' && (
        <div className="discovery-stats" style={{marginBottom:20}}>
          <div className="stat-item"><div className="stat-number">{shop?.productCount||0}</div><div className="stat-label">商品数</div></div>
          <div className="stat-item"><div className="stat-number">{shop?.orderCount||0}</div><div className="stat-label">订单</div></div>
          <div className="stat-item"><div className="stat-number">${shop?.totalRevenue||0}</div><div className="stat-label">总收入</div></div>
          <div className="stat-item"><div className="stat-number">{shop?.tierInfo?.badge}</div><div className="stat-label">{shop?.tierInfo?.label}</div></div>
        </div>
      )}

      {tab === 'products' && (
        <>
          <div style={{textAlign:'center',marginBottom:16}}>
            <button className="btn btn-primary" onClick={() => setShowProductForm(!showProductForm)}
              disabled={maxProducts !== -1 && products.length >= maxProducts}>
              {showProductForm ? '✕ 收起' : maxProducts !== -1 && products.length >= maxProducts ? '🔒 已达数量上限，升级解锁' : '📦 上架新商品'}
            </button>
          </div>

          {showProductForm && (
            <div className="card form-card" style={{margin:'0 auto 20px',maxWidth:500}}>
              <h3>📝 上架商品</h3>
              <div className="field"><label>商品名</label><input value={pForm.title} onChange={e=>setPForm(f=>({...f,title:e.target.value}))} placeholder="你的本土好物名字" /></div>
              <div className="field"><label>描述</label><textarea value={pForm.description} onChange={e=>setPForm(f=>({...f,description:e.target.value}))} rows={2} placeholder="介绍给全球买家..." /></div>
              <div style={{display:'flex',gap:10}}>
                <div className="field" style={{flex:1}}><label>价格</label><input type="number" value={pForm.price} onChange={e=>setPForm(f=>({...f,price:e.target.value}))} placeholder="0" /></div>
                <div className="field" style={{width:120}}><label>货币</label><select value={pForm.currency} onChange={e=>setPForm(f=>({...f,currency:e.target.value}))}><option value="USD">$ USD</option><option value="EUR">€ EUR</option><option value="JPY">¥ JPY</option><option value="CNY">¥ CNY</option><option value="KRW">₩ KRW</option><option value="RUB">₽ RUB</option><option value="GBP">£ GBP</option></select></div>
              </div>
              <div className="field"><label>Emoji</label><input value={pForm.image} onChange={e=>setPForm(f=>({...f,image:e.target.value}))} placeholder="📦" /></div>
              <div className="field"><label>类别</label><select value={pForm.category} onChange={e=>setPForm(f=>({...f,category:e.target.value}))}><option value="handmade">🎨 手作</option><option value="food">🍔 美食</option><option value="fashion">👗 时尚</option><option value="art">🖼️ 艺术</option><option value="beauty">🧴 美妆</option><option value="entertainment">🎬 娱乐</option><option value="outdoor">🏔️ 户外</option></select></div>
              <button className="btn btn-primary btn-block" onClick={publishProduct}>🚀 上架</button>
            </div>
          )}

          <div className="users-grid">
            {products.map(p => (
              <div key={p.id} className="product-card">
                <div className="product-image">{p.image||'📦'}</div>
                <div className="product-info">
                  <div className="product-title">{p.title}</div>
                  <div className="product-desc">{p.description}</div>
                  <div className="product-meta">
                    <span className="meta-badge" style={p.status==='active'?{background:'rgba(74,222,128,0.15)',color:'#4ade80'}:{background:'rgba(255,107,107,0.15)',color:'#ff6b6b'}}>{p.status==='active'?'🟢 在售':'🔴 已售'}</span>
                    <span className="meta-badge">{CURR_SYM[p.currency]||'$'}{p.price}</span>
                  </div>
                </div>
              </div>
            ))}
            {products.length === 0 && <div style={{gridColumn:'1/-1',textAlign:'center',padding:40,color:'var(--text-dim)'}}>还没有上架商品 📦</div>}
          </div>
        </>
      )}

      {tab === 'upgrade' && (
        <div className="plans-grid" style={{maxWidth:700}}>
          <ShopPlans currentTier={shop?.tier} onUpgrade={upgradeShop} />
        </div>
      )}
    </div>
  );
}

function ShopPlans({ currentTier, onUpgrade }) {
  const [plans, setPlans] = useState([]);
  useEffect(() => { API.get('/shops/plans').then(r => setPlans(r.data)).catch(() => {}); }, []);
  const isCurrent = (id) => currentTier === id;
  return plans.map(p => (
    <div key={p.id} className={`plan-card ${p.id === 'basic' ? 'popular' : ''} ${isCurrent(p.id) ? 'owned' : ''}`}>
      {p.id === 'basic' && <div className="plan-badge">🔥 最受欢迎</div>}
      {isCurrent(p.id) && <div className="plan-badge owned-badge">✅ 当前套餐</div>}
      <div className="plan-header">
        <div className="plan-name">{p.badge} {p.label}</div>
        <div className="plan-price"><span className="price-num">{p.priceLabel||'免费'}</span><span className="price-period">{p.price > 0 ? '/月' : ''}</span></div>
      </div>
      <ul className="plan-features">
        <li>📦 最多 {p.maxProducts === -1 ? '无限' : p.maxProducts} 件商品</li>
        <li>💳 佣金仅 {Math.round(p.commission * 100)}%</li>
        {p.days > 0 && <li>🆓 试用 {p.days} 天</li>}
        {p.featured && <li>⭐ 推荐曝光</li>}
      </ul>
      {onUpgrade && !isCurrent(p.id) && (
        <button className={`btn btn-plan ${p.id === 'basic' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => onUpgrade(p.id)}>
          立即升级
        </button>
      )}
    </div>
  ));
}
